import type { ChangeEvent, FunctionComponent, ReactElement } from 'react';

import { uniqueId } from 'lodash-es';

import {
  type AriaProps,
  ariaToReactProps,
} from '@iconik-io/shared-lib/src/react/a11y/aria';

import styles from './radiobuttons.module.css';

type Props = {
  name: string;
  value: string;
  checked: boolean;
  disabled?: boolean;
  label: string | ReactElement;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  aria?: AriaProps;
};

const RadioButton: FunctionComponent<Props> = (props) => {
  const id = uniqueId(`${props.name}_${props.value}`);
  return (
    <label htmlFor={id} className={styles.label}>
      <input
        type="radio"
        id={id}
        value={props.value}
        name={props.name}
        checked={props.checked}
        disabled={props.disabled}
        onChange={props.onChange}
        className={styles.control}
        {...ariaToReactProps(props.aria)}
      />
      <span className={styles.pseudo_control} />
      <span className={props.checked ? styles.text_checked : styles.text}>
        {props.label}
      </span>
    </label>
  );
};

export default RadioButton;
